import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IDeleteState, IResponse } from '../../types'

const sharedApiClient = AdminApiClient.getInstance()

export const fetchDeleteEmployee = createAsyncThunk(
  'listEmployees/fetchDeleteEmployee',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await sharedApiClient.deleteEmployee(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IDeleteState = {
  isLoading: false,
  response: null,
  error: null
}

const deleteEmployeeSlice = createSlice({
  name: 'employees/delete',
  initialState,
  reducers: {
    resetDeleteEmployee: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchDeleteEmployee.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchDeleteEmployee.fulfilled, (state, action: PayloadAction<IResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchDeleteEmployee.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default deleteEmployeeSlice.reducer
export const { resetDeleteEmployee } = deleteEmployeeSlice.actions
